import { EmissionDocument } from '../../../EmissionRequest';

export default function makeEmissionDocument(
  name: string,
  contentFile: string,
  fileName: string,
): EmissionDocument {
  const extension = fileName.substring(
    fileName.lastIndexOf('.'),
    fileName.length,
  );
  const mime = extension === '.png' ? 'image/png' : 'application/pdf';
  return {
    id: '',
    name: `${name}${extension}`,
    content: contentFile,
    mime,
  };
}
